import styled from 'styled-components'

export const MenuItemButtonContainer = styled.button`
  max-width: calc(100vw - 40px);
  min-width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  background-color: var(--neutral-theme);
  border-bottom: 1px solid var(--gray200);

  &:last-child {
    border-bottom: none;
  }

  &:only-child {
    border-bottom: none;
  }
`

export const DescriptionArea = styled.div`
  max-width: calc(100vw - 40px);
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  text-align: start;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
  gap: 4px;
`
